"use strict";
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Log levels, for RecordType == Log.
 */
var Level;
(function (Level) {
    Level["ERROR"] = "ERROR";
    Level["WARN"] = "WARN";
    Level["INFO"] = "INFO";
    Level["DEBUG"] = "DEBUG";
    Level["TRACE"] = "TRACE";
})(Level = exports.Level || (exports.Level = {}));
//# sourceMappingURL=Level.js.map